'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--MediumWithCircle';

var EntypoMediumWithCircle = function EntypoMediumWithCircle(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M10,0.3999634c-5.3019409,0-9.5999756,4.2980957-9.5999756,9.6000366S4.6980591,19.5999756,10,19.5999756S19.5999756,15.3019409,19.5999756,10S15.3019409,0.3999634,10,0.3999634z M14.2000122,7.666687h-0.1165771c0,0-0.3500977,0-0.3500977,0.3500977c0,0.3500366,0,3.9666748,0,3.9666748s0,0.3497925,0.3500977,0.3497925h0.1165771v0.9333496h-2.7999878V12.333252h0.4666138V7.9933472h-0.0466309l-1.4301147,5.2732544H9.1304321L7.7133179,7.9933472H7.666687v4.3399048h0.4666748v0.9333496h-2.333374V12.333252h0.1165771c0,0,0.3500977,0,0.3500977-0.3500366s0-3.9667358,0-3.9667358s0-0.3497925-0.3500977-0.3497925H5.7999878V6.7333984H8.895874l1.0858765,4.0408325h0.0357666l1.0959473-4.0408325h3.0865479V7.666687z' })
    );
};

exports.default = EntypoMediumWithCircle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/MediumWithCircle.js
// module id = ./node_modules/react-entypo/lib/entypo/MediumWithCircle.js
// module chunks = 2